module.exports = __webpack_public_path__ + "static/media/by.e3816126.svg";